import { render, staticRenderFns } from "./BudgetReport.vue?vue&type=template&id=bbafc63e&scoped=true"
import script from "./BudgetReport.vue?vue&type=script&lang=js"
export * from "./BudgetReport.vue?vue&type=script&lang=js"
import style0 from "./BudgetReport.vue?vue&type=style&index=0&id=bbafc63e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbafc63e",
  null
  
)

export default component.exports